export default "assets/images/underline_green_2-7dceacd3.svg";